import React, { useState } from 'react';
import { FeedPost } from './FeedPost';
import { ShareModal } from './ShareModal';
import { SearchAndFilters } from './SearchAndFilters';
import { ImageUpload } from './ImageUpload';

interface SocialFeedProps {
  filter?: 'all' | 'friends' | 'team';
}

export const SocialFeed: React.FC<SocialFeedProps> = ({ filter = 'all' }) => {
  const [activeFilter, setActiveFilter] = useState(filter);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [selectedAchievement, setSelectedAchievement] = useState<any>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filters, setFilters] = useState({
    type: 'all',
    period: 'all',
    sortBy: 'recent'
  });
  const [postText, setPostText] = useState('');
  const [selectedImages, setSelectedImages] = useState<File[]>([]);
  const [showImageUpload, setShowImageUpload] = useState(false);

  // Mock de posts
  const posts = [
    {
      id: '1',
      author: {
        name: 'Maria Silva',
        avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20avatar%20portrait%20simple%20background%20friendly%20smile%20corporate%20attire&width=100&height=100&seq=feed-avatar-001&orientation=squarish',
        level: 15
      },
      achievement: {
        type: 'level' as const,
        title: 'Nível 15 Alcançado!',
        description: 'Parabéns! Você subiu para o nível 15 e desbloqueou novas recompensas.',
        icon: 'ri-vip-crown-line'
      },
      timestamp: 'Há 2 horas',
      reactions: [],
      comments: [
        {
          id: 'c1',
          author: {
            name: 'João Santos',
            avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20avatar%20portrait%20simple%20background%20friendly%20smile&width=100&height=100&seq=feed-comment-001&orientation=squarish',
            level: 12
          },
          content: 'Parabéns Maria! Você é inspiração para todos nós! 🎉',
          timestamp: 'Há 1 hora',
          likes: 5,
          liked: false
        }
      ]
    },
    {
      id: '2',
      author: {
        name: 'Carlos Oliveira',
        avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20avatar%20portrait%20simple%20background%20confident%20smile&width=100&height=100&seq=feed-avatar-002&orientation=squarish',
        level: 18
      },
      achievement: {
        type: 'badge' as const,
        title: 'Mestre das Vendas',
        description: 'Conquistou o distintivo por atingir 100% da meta de vendas por 3 meses consecutivos!',
        icon: 'ri-medal-line'
      },
      timestamp: 'Há 5 horas',
      reactions: [],
      comments: []
    },
    {
      id: '3',
      author: {
        name: 'Ana Costa',
        avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20avatar%20portrait%20simple%20background%20warm%20smile%20elegant&width=100&height=100&seq=feed-avatar-003&orientation=squarish',
        level: 22
      },
      achievement: {
        type: 'mission' as const,
        title: 'Missão Épica Completada',
        description: 'Completou a missão "Campeão de Vendas" e ganhou 5.000 XP!',
        icon: 'ri-flag-line'
      },
      timestamp: 'Há 1 dia',
      reactions: [],
      comments: [
        {
          id: 'c2',
          author: {
            name: 'Pedro Lima',
            avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20avatar%20portrait%20simple%20background%20friendly&width=100&height=100&seq=feed-comment-002&orientation=squarish',
            level: 14
          },
          content: 'Incrível Ana! Como você conseguiu? 💪',
          timestamp: 'Há 20 horas',
          likes: 3,
          liked: false
        },
        {
          id: 'c3',
          author: {
            name: 'Ana Costa',
            avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20avatar%20portrait%20simple%20background%20warm%20smile%20elegant&width=100&height=100&seq=feed-avatar-003&orientation=squarish',
            level: 22
          },
          content: 'Foco e dedicação! Você também consegue! 🎯',
          timestamp: 'Há 19 horas',
          likes: 2,
          liked: false
        }
      ]
    },
    {
      id: '4',
      author: {
        name: 'Roberto Alves',
        avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20man%20avatar%20portrait%20simple%20background%20confident%20professional&width=100&height=100&seq=feed-avatar-004&orientation=squarish',
        level: 20
      },
      achievement: {
        type: 'victory' as const,
        title: '🏆 Campeão da Campanha Q1',
        description: 'Conquistou o 1º lugar na campanha do primeiro trimestre com 15.000 pontos!',
        icon: 'ri-trophy-line'
      },
      timestamp: 'Há 2 dias',
      reactions: [],
      comments: []
    },
    {
      id: '5',
      author: {
        name: 'Juliana Ferreira',
        avatar: 'https://readdy.ai/api/search-image?query=professional%20business%20woman%20avatar%20portrait%20simple%20background%20bright%20smile%20modern&width=100&height=100&seq=feed-avatar-005&orientation=squarish',
        level: 16
      },
      achievement: {
        type: 'reward' as const,
        title: 'Recompensa Resgatada',
        description: 'Resgatou um iPhone 15 Pro com seus pontos acumulados!',
        icon: 'ri-gift-line'
      },
      timestamp: 'Há 3 dias',
      reactions: [],
      comments: []
    }
  ];

  const filterOptions = [
    { id: 'all', label: 'Todos', icon: 'ri-global-line' },
    { id: 'friends', label: 'Amigos', icon: 'ri-user-heart-line' },
    { id: 'team', label: 'Minha Equipe', icon: 'ri-team-line' }
  ];

  const handleShare = (post: any) => {
    setSelectedAchievement({
      title: post.achievement.title,
      description: post.achievement.description,
      image: post.achievement.image,
      type: post.achievement.type
    });
    setShareModalOpen(true);
  };

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    // Implementar lógica de busca
    console.log('Buscando:', query);
  };

  const handleFilterChange = (newFilters: any) => {
    setFilters(newFilters);
    // Implementar lógica de filtros
    console.log('Filtros aplicados:', newFilters);
  };

  // Filtrar posts baseado na busca e filtros
  const filteredPosts = posts.filter(post => {
    // Filtro de busca
    if (searchQuery) {
      const searchLower = searchQuery.toLowerCase();
      const matchesSearch = 
        post.author.name.toLowerCase().includes(searchLower) ||
        post.achievement.title.toLowerCase().includes(searchLower) ||
        post.achievement.description.toLowerCase().includes(searchLower);
      if (!matchesSearch) return false;
    }

    // Filtro de tipo
    if (filters.type !== 'all' && post.achievement.type !== filters.type) {
      return false;
    }

    return true;
  });

  return (
    <div className="space-y-6">
      {/* Busca e Filtros Avançados */}
      <SearchAndFilters 
        onSearch={handleSearch}
        onFilterChange={handleFilterChange}
      />

      {/* Filtros Rápidos */}
      <div className="bg-white rounded-xl shadow-md border border-gray-200 p-4">
        <div className="flex items-center gap-2">
          {filterOptions.map((f) => (
            <button
              key={f.id}
              onClick={() => setActiveFilter(f.id as any)}
              className={`flex items-center gap-2 px-4 py-2 rounded-lg font-medium transition-all ${
                activeFilter === f.id
                  ? 'bg-gradient-to-r from-teal-500 to-cyan-500 text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              <i className={`${f.icon} text-lg`}></i>
              {f.label}
            </button>
          ))}
        </div>
      </div>

      {/* Resultados da Busca */}
      {searchQuery && (
        <div className="bg-teal-50 border border-teal-200 rounded-xl p-4">
          <p className="text-sm text-teal-800">
            <i className="ri-search-line mr-2"></i>
            Mostrando {filteredPosts.length} resultado(s) para "{searchQuery}"
          </p>
        </div>
      )}

      {/* Create Post */}
      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6">
        <div className="flex items-start gap-4">
          <img
            src="https://readdy.ai/api/search-image?query=professional%20business%20person%20avatar%20portrait%20simple%20background%20corporate%20style%20friendly%20smile&width=100&height=100&seq=feed-current-user-001&orientation=squarish"
            alt="Você"
            className="w-12 h-12 rounded-full object-cover"
          />
          <div className="flex-1">
            <textarea
              value={postText}
              onChange={(e) => setPostText(e.target.value)}
              placeholder="Compartilhe sua conquista..."
              className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl resize-none focus:outline-none focus:ring-2 focus:ring-teal-500 text-slate-800"
              rows={3}
            />
            
            {/* Image Upload */}
            {showImageUpload && (
              <div className="mt-3">
                <ImageUpload
                  onImagesSelected={setSelectedImages}
                  maxImages={4}
                />
              </div>
            )}

            <div className="flex items-center justify-between mt-3">
              <div className="flex items-center gap-2">
                <button
                  onClick={() => setShowImageUpload(!showImageUpload)}
                  className={`px-4 py-2 rounded-xl font-medium transition-all ${
                    showImageUpload
                      ? 'bg-teal-100 text-teal-700'
                      : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                  }`}
                >
                  <i className="ri-image-line mr-2"></i>
                  Foto
                </button>
                <button className="px-4 py-2 bg-slate-100 text-slate-600 rounded-xl font-medium hover:bg-slate-200 transition-colors">
                  <i className="ri-trophy-line mr-2"></i>
                  Conquista
                </button>
                <button className="px-4 py-2 bg-slate-100 text-slate-600 rounded-xl font-medium hover:bg-slate-200 transition-colors">
                  <i className="ri-emotion-line mr-2"></i>
                  Emoji
                </button>
              </div>
              <button className="px-6 py-2 bg-gradient-to-r from-teal-500 to-cyan-600 text-white rounded-xl font-bold hover:scale-105 transition-transform shadow-lg whitespace-nowrap">
                Publicar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Feed de Posts */}
      <div className="space-y-6">
        {filteredPosts.length > 0 ? (
          filteredPosts.map((post) => (
            <FeedPost
              key={post.id}
              post={post}
              onShare={() => handleShare(post)}
            />
          ))
        ) : (
          <div className="bg-white rounded-xl shadow-md border border-gray-200 p-12 text-center">
            <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Nenhum resultado encontrado
            </h3>
            <p className="text-gray-600">
              Tente ajustar seus filtros ou buscar por outros termos
            </p>
          </div>
        )}
      </div>

      {/* Botão Carregar Mais */}
      {filteredPosts.length > 0 && (
        <div className="flex justify-center">
          <button className="px-6 py-3 bg-white text-teal-600 border-2 border-teal-500 rounded-lg font-medium hover:bg-teal-50 transition-colors">
            <i className="ri-refresh-line mr-2"></i>
            Carregar mais conquistas
          </button>
        </div>
      )}

      {/* Modal de Compartilhamento */}
      {selectedAchievement && (
        <ShareModal
          isOpen={shareModalOpen}
          onClose={() => setShareModalOpen(false)}
          achievement={selectedAchievement}
        />
      )}
    </div>
  );
};
